// extracted by mini-css-extract-plugin
export var container = "EmployeeDetail-module--container--Ve-Kd";
export var ctas = "#226355";
export var grayBackground = "#f6f8fb";
export var header = "EmployeeDetail-module--header--weSHR";
export var imageContainer = "EmployeeDetail-module--imageContainer--Jf1gh";
export var textContainer = "EmployeeDetail-module--textContainer--cVK4H";
export var title = "EmployeeDetail-module--title--ttI3L";